import { defineStore } from "pinia";

const inFlight = new Map();

// Editor-tree hashtag cache. StoriesWithHashtagPage production
// rendering resolves `pageEntities.storiesWithHashtag` (URL var
// `hashtag` — a string slug, not an integer id) and lazy-fetches the
// hashtag record here through the page mixin.
export const useHashtagStore = defineStore("dynamic-component-editor-hashtag-store", {
  state: () => ({
    hashtags: {},
  }),
  actions: {
    async getOrFetchHashtag(hashtag) {
      if (!hashtag) {
        return null;
      }
      const cached = this.hashtags?.[hashtag];
      if (cached?.hashtag || cached?.hashtagId || cached?.hashtag_id) {
        return cached;
      }
      if (inFlight.has(hashtag)) {
        return await inFlight.get(hashtag);
      }
      const promise = new Promise(resolve => {
        this.apiGet(
          "/following/entity/hashtag",
          { entity_id: hashtag },
          data => {
            if (!this.hashtags || typeof this.hashtags !== "object") {
              this.hashtags = {};
            }
            this.hashtags[hashtag] = data;
            resolve(data);
          },
          () => resolve(null),
        );
      }).finally(() => {
        inFlight.delete(hashtag);
      });
      inFlight.set(hashtag, promise);
      return await promise;
    },
  },
});
